// ================================================
// ReportForm.jsx - Versione Modal Centrato
// ================================================
// Sostituisci TUTTO il contenuto di src/components/ReportForm.jsx con questo

import React, { useState, useRef, useEffect } from 'react';
import { auth, submitReport } from '../firebase';

const ReportForm = ({ isVisible, selectedDate, position, onSubmit, onClose }) => {
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const formRef = useRef(null);
  
  // Reset message when form is opened with a new date
  useEffect(() => {
    if (isVisible) {
      setMessage('');
      setError('');
    }
  }, [isVisible, selectedDate]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (message.trim() === '') {
      setError('Per favore, inserisci una descrizione dell\'errore');
      return;
    }

    setError('');
    setIsSubmitting(true);
    
    try {
      console.log(`ReportForm: Invio segnalazione per data ${selectedDate}`);

      const reportData = {
        date: selectedDate,
        description: message,
        status: "In attesa"
      };
      
      console.log("ReportForm: Dati segnalazione", reportData);
      console.log("ReportForm: userId", auth.currentUser?.uid);
      
      if (!auth.currentUser) {
        throw new Error("Utente non autenticato");
      }
      
      const result = await submitReport(reportData, auth.currentUser.uid);
      console.log("ReportForm: Segnalazione inviata con successo", result);
      
      onSubmit(selectedDate, message);
      setMessage('');
    } catch (error) {
      console.error("ReportForm: Errore nell'invio della segnalazione:", error);
      setError("Si è verificato un errore durante l'invio della segnalazione. Riprova più tardi.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // ✅ Stile per overlay sfondo scuro
  const overlayStyle = {
    display: isVisible ? 'flex' : 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    padding: '20px',
    animation: 'fadeIn 0.3s ease-out'
  };

  // ✅ Stile per il form centrato
  const formStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '30px',
    maxWidth: '600px',
    width: '100%',
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
    position: 'relative',
    animation: 'slideIn 0.3s ease-out'
  };

  // Impedisce lo scroll della pagina quando il modal è aperto
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isVisible]);

  // Gestisce ESC per chiudere
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && isVisible && !isSubmitting) {
        onClose();
      }
    };
    
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isVisible, isSubmitting, onClose]);

  return (
    <>
      {/* Overlay che copre tutto lo schermo */}
      <div style={overlayStyle} onClick={onClose}>
        {/* Form centrato che non si chiude cliccandoci sopra */}
        <div style={formStyle} onClick={(e) => e.stopPropagation()} ref={formRef}>
          
          {/* Pulsante chiudi (X) in alto a destra */}
          <button
            onClick={onClose}
            disabled={isSubmitting}
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              background: 'transparent',
              border: 'none',
              fontSize: '28px',
              cursor: 'pointer',
              color: '#999',
              lineHeight: '1',
              padding: '0',
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.color = '#333'}
            onMouseLeave={(e) => e.target.style.color = '#999'}
            title="Chiudi (ESC)"
          >
            ×
          </button>

          {/* Titolo */}
          <h3 style={{ 
            marginTop: 0, 
            marginBottom: '20px',
            fontSize: '24px',
            color: '#333',
            fontWeight: '600'
          }}>
            Segnala un errore
          </h3>

          {/* Info data selezionata */}
          <p style={{
            marginBottom: '15px',
            color: '#666',
            fontSize: '14px'
          }}>
            Data selezionata: <strong>{new Date(selectedDate).toLocaleDateString('it-IT', {
              day: '2-digit',
              month: 'long',
              year: 'numeric'
            })}</strong>
          </p>

          {/* Messaggio di errore */}
          {error && (
            <div style={{ 
              color: '#d32f2f', 
              backgroundColor: '#ffebee',
              padding: '12px 15px',
              borderRadius: '6px',
              marginBottom: '15px',
              fontSize: '14px',
              border: '1px solid #ef9a9a',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <span style={{ fontSize: '18px' }}>⚠️</span>
              <span>{error}</span>
            </div>
          )}

          {/* Textarea per la descrizione */}
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Descrivi l'errore riscontrato&#10;&#10;Esempio: 'Orario di entrata errato, l'orario corretto è 8:30'&#10;oppure 'Ore straordinarie non registrate'"
            disabled={isSubmitting}
            autoFocus
            style={{ 
              width: '100%', 
              minHeight: '120px',
              marginBottom: '20px',
              padding: '12px',
              border: '2px solid #e0e0e0',
              borderRadius: '8px',
              fontSize: '14px',
              fontFamily: 'inherit',
              resize: 'vertical',
              boxSizing: 'border-box',
              transition: 'border-color 0.2s',
              outline: 'none'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3498db'}
            onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
          />

          {/* Info caratteri */}
          <div style={{
            fontSize: '12px',
            color: '#999',
            marginBottom: '20px',
            textAlign: 'right'
          }}>
            {message.length} caratteri
          </div>

          {/* Pulsanti azione */}
          <div style={{ 
            display: 'flex', 
            gap: '10px', 
            justifyContent: 'flex-end',
            flexWrap: 'wrap'
          }}>
            <button 
              className="btn btn-secondary" 
              onClick={onClose}
              disabled={isSubmitting}
              style={{
                padding: '12px 24px',
                border: 'none',
                borderRadius: '8px',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s',
                backgroundColor: '#e0e0e0',
                color: '#333',
                opacity: isSubmitting ? 0.6 : 1
              }}
              onMouseEnter={(e) => !isSubmitting && (e.target.style.backgroundColor = '#d0d0d0')}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#e0e0e0'}
            >
              Annulla
            </button>
            
            <button 
              className="btn btn-success" 
              onClick={handleSubmit}
              disabled={isSubmitting || !message.trim()}
              style={{
                padding: '12px 24px',
                border: 'none',
                borderRadius: '8px',
                cursor: (isSubmitting || !message.trim()) ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s',
                backgroundColor: '#27ae60',
                color: 'white',
                opacity: (isSubmitting || !message.trim()) ? 0.6 : 1,
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
              onMouseEnter={(e) => {
                if (!isSubmitting && message.trim()) {
                  e.target.style.backgroundColor = '#229954';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(39, 174, 96, 0.3)';
                }
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#27ae60';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              {isSubmitting ? (
                <>
                  <span style={{ 
                    display: 'inline-block',
                    width: '14px',
                    height: '14px',
                    border: '2px solid white',
                    borderTopColor: 'transparent',
                    borderRadius: '50%',
                    animation: 'spin 0.6s linear infinite'
                  }}></span>
                  Invio in corso...
                </>
              ) : (
                <>
                  📝 Invia Segnalazione
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Stili per animazioni */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: scale(0.9) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Responsive per mobile */
        @media (max-width: 768px) {
          .report-form-modal {
            padding: 20px;
            margin: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default ReportForm;